import { useLocation } from 'react-router-dom';

// In-app webview (?webview=1) on blog + price pages: no header, footer, assistant
// or outbound navigation. Done through rendering/CSS — never by deleting
// React-owned DOM nodes (that crashed the page).
export function useWebviewMode() {
  const location = useLocation();
  const isWebview = new URLSearchParams(location.search).get('webview') === '1';
  const path = location.pathname.toLowerCase();
  return isWebview && (path.startsWith('/blog') || path === '/pris-time-for-time');
}

export default function WebviewMode() {
  return null;
}